import { h } from 'preact';
import './style.scss';
import { useRef } from 'preact/compat';

interface Props extends Omit<h.JSX.HTMLAttributes<HTMLInputElement>, 'onChange'> {
  className?: string;
  inputClassName?: string;
  label: string;
  onChange?: (value) => void;
}

function RadioButton({
  className = '',
  inputClassName = '',
  name = 'radio-button',
  label,
  value,
  checked,
  onChange,
  ...rest
}: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = () => {
    if (onChange) onChange(checked ? '' : value);
    inputRef.current.checked = !checked;
  };

  return (
    <div className={`radio-button_ta ${className}`} onClick={handleChange}>
      <label className="radio-button__label_ta" htmlFor={name}>
        <input
          type="radio"
          className={`${inputClassName}`}
          name={name}
          value={value}
          checked={checked}
          ref={inputRef}
          onChange={c => c.preventDefault()}
          {...rest}
        />
        <label>{label}</label>
      </label>
    </div>
  );
}

export default RadioButton;
